export default class Async {
  static setTimeout(callback, interval, ...restArgs) {
    const timeoutId = window.setTimeout(callback, interval, ...restArgs);

    return () => clearTimeout(timeoutId);
  }

  static setInterval(callback, interval, ...restArgs) {
    const intervalId = window.setInterval(callback, interval, ...restArgs);

    return () => clearInterval(intervalId);
  }

  static deferredRun(func, ...args) {
    setTimeout(func, 0, ...args);
  }

  static debounce(func, wait, immediate) {
    let timeout;

    return (...args) => {
      const later = () => {
        timeout = null;
        if (!immediate) func(...args);
      };

      const callNow = immediate && !timeout;

      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func(...args);
    };
  }

  static async runInSequence(tasks) {
    const result = await tasks.reduce(
      (promiseChain, currentTask) => {
        return promiseChain.then(async(chainResults) => {
          const currentResult = await currentTask();

          return [...chainResults, currentResult];
        });
      },
      Promise.resolve([])
    );

    return result;
  }

  static async delay(time) {
    await new Promise((resolve) => {
      setTimeout(resolve, time);
    });
  }

  static async waitForever() {
    await new Promise(() => {});
  }

  static async loopWhile(task, condition = true) {
    if (condition) {
      condition = await task();
      await Async.loopWhile(task, condition);
    }
  }
}
